import { ReactComponent as JumpNextIcon } from "../../common/images/svg/JumpNext.svg";
import { ReactComponent as NextIcon } from "../../common/images/svg/Next.svg";

interface INextPaginationProps {
  totalPage: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

const NextPagination = ({
  totalPage,
  currentPage,
  setCurrentPage,
}: INextPaginationProps) => {
  return (
    <div className="custom-paging">
      <div
        className="button-prev-next"
        onClick={(e) => {
          e.stopPropagation();
          if (currentPage < totalPage) setCurrentPage(currentPage + 1);
          else setCurrentPage(totalPage);
        }}
      >
        <NextIcon />
      </div>
      <div
        className="button-prev-next"
        onClick={(e) => {
          e.stopPropagation();
          if (currentPage + 3 <= totalPage) setCurrentPage(currentPage + 3);
          else setCurrentPage(totalPage);
        }}
      >
        <JumpNextIcon />
      </div>
    </div>
  );
};

export default NextPagination;
